import { flashVersion, isFlashSupported, isIframe, supportsPassive } from '../utils';
import { Browser } from './browser';
import { OS } from './OS';

export class Features {
    static get flash(): boolean {
        return isFlashSupported();
    }

    static get flashVersion(): number {
        return flashVersion();
    }

    static get frame(): boolean {
        return isIframe();
    }

    static get passiveEvents(): boolean {
        return supportsPassive();
    }

    static get backgroundLoading(): boolean {
        return !(OS.iOS || Browser.safari);
    }
}
